import { Injectable } from '@angular/core';

import { DataService } from './data.service';
import { TermsAndConditions } from '../models/terms-and-conditions.model';

@Injectable({
  providedIn: 'root'
})
export class TermsAndConditionsService extends DataService<TermsAndConditions> {
  constructor() {
    super();
  }

  public async load(termsAndConditions: string, termsAndConditionsDate: string) {
    this.set({ termsAndConditions, termsAndConditionsDate } as TermsAndConditions)
  }
}
